import React from "react";
import { StyledChip } from "../styled/StyledChip.styled";
import PropTypes from "prop-types";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default function Chip({ label, color }) {
  return <StyledChip label={capitalizeFirstLetter(label)} color={color} />;
}

Chip.propTypes = {
  label: PropTypes.oneOf(["Success", "Pending", "Error"]),
  color: PropTypes.oneOf(["success", "warning", "error"]),
};

Chip.defaultProps = {
  label: "Success",
  color: "success",
};
